module.exports = __webpack_public_path__ + "img/hr_login_white.5aefb255.png";